import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
import { checkboxProps } from 'ant-design-vue/es/checkbox';
import { omit } from 'lodash-es';
import { Checkbox } from 'ant-design-vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  ...checkboxProps(),
  trueValue: {
    type: [Number, Boolean, String],
    default: true,
  },
  falseValue: {
    type: [Number, Boolean, String],
    default: false,
  },
},
  emits: ['update:checked', 'change'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const getProps = computed(() => {
  return omit(props, ['onUpdate:checked', 'onChange']);
});

const checkedModel = computed<boolean>({
  get() {
    return props.checked === props.trueValue;
  },
  set(val) {
    emit('update:checked', val ? props.trueValue : props.falseValue);
  },
});

const handleChange = (e) => {
  const evt = {
    ...e,
    target: {
      ...e.target,
      checked: e.target.checked ? props.trueValue : props.falseValue,
    },
  };
  emit('change', evt);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Checkbox), _mergeProps(getProps.value, {
    checked: checkedModel.value,
    "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((checkedModel).value = $event)),
    onChange: handleChange
  }), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16, ["checked"]))
}
}

})